import { CompanyResultViewTypes } from 'src/app/core/enums/company-result-view.enum';
import { IOptions } from 'src/app/core/interfaces/common/common/options.interface';

export abstract class AbstractBusinessProfileService {
  abstract loadLegalFormOfBusiness(): Promise<IOptions[]>;
  abstract loadBusinessIndustry(): Promise<IOptions[]>;
  abstract checkRescoreEligability(): Promise<boolean>;
  abstract rescoreProspect(): Promise<CompanyResultViewTypes>;
}
